import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const PricingPage = lazy(() => import('../pages/Pricing'));
const HrmPricingPage = lazy(() => import('../pages/HrmPricing'));
const ClinicoPricingPage = lazy(() => import('../pages/ClinicoPricing'));

const PricingRoutes = [
    {
        path: '/pricing',
        element: <Navigate to="../pricing/crm" replace />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/pricing/crm',
        element: <PricingPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/pricing/hrm',
        element: <HrmPricingPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/pricing/clinico',
        element: <ClinicoPricingPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { PricingRoutes };
